import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const ZooIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "ZooIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        d="M18.8452 9.00787C18.8452 9.33136 18.5829 9.59366 18.2594 9.59366C17.9359 9.59366 17.6736 9.33136 17.6736 9.00787C17.6736 8.68439 17.9359 8.42209 18.2594 8.42209C18.5829 8.42209 18.8452 8.68439 18.8452 9.00787Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.8315 3.73582H16.0579C16.0524 3.73201 16.0469 3.72819 16.0412 3.72438C15.305 3.21687 13.9346 2.27251 11.976 2.89766C11.9252 2.91399 11.1987 3.15248 10.4709 3.73582H9.98029C5.78123 3.73582 2.3651 7.15195 2.3651 11.351C2.3651 11.3736 2.36418 11.4018 2.36342 11.4357C2.34923 12.0261 2.30605 13.8225 3.87129 16.1304C4.41878 16.9374 4.70808 17.9455 4.70824 19.0457V20.7236C4.70824 21.047 4.97038 21.3093 5.29402 21.3093H7.67622C7.9997 21.3093 8.262 21.047 8.262 20.7236V17.7946H10.6051V20.7236C10.6051 21.047 10.8674 21.3093 11.1909 21.3093H13.5731C13.8966 21.3093 14.1589 21.047 14.1589 20.7236C14.1589 18.4515 14.6241 16.4166 15.5812 14.5023L16.2468 13.1714L17.3768 13.3598C18.2276 13.5016 18.8452 14.2306 18.8452 15.0932V16.0373C18.8452 16.3603 18.5824 16.6231 18.2594 16.6231C18.103 16.6231 17.9559 16.562 17.8453 16.4514C17.6167 16.2228 17.2454 16.2227 17.0169 16.4514L15.3611 18.1071C15.1324 18.3359 15.1324 18.7068 15.3611 18.9355C16.3353 19.91 17.7409 20.3384 19.1386 20.0183C20.9608 19.6011 22.3599 17.6236 22.3599 15.7837V9.26407C22.3599 6.21583 19.8799 3.73582 16.8315 3.73582ZM21.1883 15.7837C21.1883 17.1492 20.1083 18.5943 18.8771 18.8763C18.0813 19.0585 17.294 18.9143 16.6441 18.481L17.5013 17.6237C17.7349 17.7357 17.9927 17.7946 18.2594 17.7946C19.2283 17.7946 20.0167 17.0064 20.0167 16.0373V15.0934C20.0167 13.6557 18.9874 12.4406 17.5692 12.2043L16.0125 11.9449C15.7588 11.9025 15.5072 12.0306 15.3923 12.2607L14.5333 13.9786C13.5763 15.8926 13.0717 17.913 12.9969 20.1379H11.7766V17.2088C11.7766 16.8854 11.5144 16.6231 11.1908 16.6231H10.0177C10.3863 16.1333 10.6051 15.5246 10.6051 14.8657C10.6051 14.5422 10.3428 14.2799 10.0194 14.2799C9.69587 14.2799 9.43357 14.5422 9.43357 14.8657C9.43357 15.8348 8.64515 16.6231 7.67622 16.6231C7.35258 16.6231 7.09043 16.8854 7.09043 17.2088V20.1379H5.8798V19.0457C5.87965 17.7103 5.52046 16.4748 4.84099 15.4729C3.48631 13.4755 3.52278 11.9614 3.53468 11.4639C3.53575 11.4189 3.53667 11.3812 3.53667 11.3512C3.53667 7.98127 6.13676 5.20738 9.43616 4.93028C9.33515 5.10865 9.24589 5.30091 9.17264 5.50752C8.68192 6.88966 9.03425 8.50831 10.2194 10.3186L11.8724 12.8435C12.0352 13.0923 12.3585 13.1795 12.6245 13.0466C13.8462 12.4356 14.6615 11.5904 15.0477 10.5344C15.3715 9.64859 15.3325 8.81409 15.3039 8.20466C15.2972 8.06244 15.2914 7.93961 15.2914 7.83631C15.2914 7.51282 15.0291 7.25053 14.7056 7.25053C14.3821 7.25053 14.1198 7.51282 14.1198 7.83631C14.1198 7.96708 14.1266 8.10914 14.1336 8.25959C14.1822 9.29718 14.2474 10.6889 12.554 11.7458L11.1996 9.67682C10.2263 8.19001 9.91544 6.91987 10.276 5.90135C10.7605 4.53264 12.3167 4.01887 12.3323 4.01399C13.7434 3.56355 14.7261 4.24089 15.3764 4.68919C15.5566 4.81324 15.668 4.90754 15.8772 4.90754H16.8316C19.234 4.90754 21.1883 6.86189 21.1883 9.26422V15.7837Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default ZooIcon;
